export const ABN_CAPTURE_REGEX = /(\d{2})(\d{3})(\d{3})(\d{3})/;

export enum InputButtonState {
  INPUT,
  LOADING,
  CLEARABLE,
}

export const PAGINATION_PAGE_SIZE = 5;
export const PAGINATION_PAGE_LIMIT = 2;
